export default "__VITE_ASSET__D54a$9jr__"